export enum TaskableType {
  call_history = "call_history",
  customer = "customer",
  ticket = "ticket",
  lead = "lead",
  opportunity = "opportunity",
  partner = "partner",
}
